/** @format */

import { Box, Link, Stack, Typography } from "@mui/material";
import { DocumentsViewDto } from "../../../Models";

interface Props {
  document: DocumentsViewDto;
}

/**
 * Blob SAS URLs frequently omit CORS rules needed for pdf.js / fetch().
 * That surfaces as "Failed to fetch" in the viewer. An iframe loads the PDF
 * via a normal navigation request, which typically succeeds for Azure blobs.
 */
export default function ViewPdf({ document }: Props) {
  const url = (document.link || "").trim();

  if (!url) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        No file link is available for this document.
      </Typography>
    );
  }

  return (
    <Stack spacing={1.5} sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: "60vh", sm: "70vh" },
          bgcolor: "grey.100",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <iframe
          title={document.documentTypeName ?? "PDF preview"}
          src={url}
          style={{
            width: "100%",
            height: "70vh",
            border: 0,
            display: "block",
          }}
        />
      </Box>
      <Link href={url} target="_blank" rel="noopener noreferrer" variant="body2">
        Open or download in a new tab
      </Link>
    </Stack>
  );
}
